export const platform = {
  BIG_COMMERCE: 'bigcommerce',
  MAGENTO_2: 'magento2',
  SHOPIFY: 'shopify',
  CODE: 'default',
  KIDZANIA: 'kidzania',

  isMagentoPlatform: type => {
    return platform.MAGENTO_2 === type
  },
  getStoreView: data => {
    const store = (data ?? []).find(store => store.code === platform.CODE)
    return store ? store.websiteId : ''
  }
}
